export default __webpack_public_path__ + "static/media/img3.d011d36f.png";